import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { JwtService } from 'src/app/auth/jwt.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';

@Injectable({
  providedIn: 'root'
})
export class GrnService {

  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService) { }

  GetGrnHeaderList() {
    return this.http.get(this.rootUrl + '/api/GRN/GetGRNList');
  } 

  // GetGrnLineList(this.orderId) {
  //   return this.http.get(this.rootUrl + '/api/GRN/GetGrnLineData');
  // }
  GetGrnLineListById(id) {
    debugger;
    const order = {
      OrderId: id
    }
    return this.http.post(this.rootUrl + '/api/GRN/GetGrnLineData', order);
  }
}
